export const motionEase = {
  outExpo: [0.16, 1, 0.3, 1] as const,
  outQuart: [0.25, 1, 0.5, 1] as const,
  outQuad: [0.2, 0, 0, 1] as const,
};
